import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const WelcomeHeader = ({ user, stats }) => {
  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-card via-card to-elevated-surface border border-border shadow-elevated">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-accent/20 via-transparent to-cyber-purple/20"></div>
        <div className="code-rain"></div>
      </div>

      <div className="relative p-6 lg:p-8">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
          {/* User Info */}
          <div className="flex items-center space-x-4">
            <div className="relative">
              <div className="w-16 h-16 lg:w-20 lg:h-20 rounded-full overflow-hidden border-2 border-accent/30 shadow-glow">
                <Image
                  src={user.avatar}
                  alt={user.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-success rounded-full border-2 border-card flex items-center justify-center">
                <Icon name="Zap" size={12} color="white" />
              </div>
            </div>
            
            <div>
              <h1 className="text-2xl lg:text-3xl font-bold text-foreground mb-1">
                Welcome back, {user.name}!
              </h1>
              <p className="text-muted-foreground mb-2">
                {user.title} • Level {user.level} Coder
              </p>
              <div className="flex items-center space-x-4 text-sm">
                <div className="flex items-center space-x-1 text-success">
                  <Icon name="Calendar" size={14} />
                  <span>{user.streak} day streak</span>
                </div>
                <div className="flex items-center space-x-1 text-accent">
                  <Icon name="Trophy" size={14} />
                  <span>{user.achievements} achievements</span>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Stats */}
          <div className="grid grid-cols-3 gap-4 lg:gap-6">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className={`w-12 h-12 mx-auto mb-2 rounded-lg ${stat.bgColor} flex items-center justify-center shadow-glow`}>
                  <Icon name={stat.icon} size={20} color="white" />
                </div>
                <div className="text-xl font-bold text-foreground">{stat.value}</div>
                <div className="text-xs text-muted-foreground">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Progress Overview */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          {user.tracks.map((track, index) => (
            <div key={index} className="p-4 rounded-lg bg-muted/20 border border-border/50">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center space-x-2">
                  <Icon name={track.icon} size={16} className={track.color} />
                  <span className="font-medium text-foreground">{track.name}</span>
                </div>
                <span className="text-sm text-muted-foreground">{track.progress}%</span>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div 
                  className={`h-2 rounded-full bg-gradient-to-r ${track.gradient}`}
                  style={{ width: `${track.progress}%` }}
                ></div>
              </div>
              <p className="text-xs text-muted-foreground mt-2">{track.nextMilestone}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;